<svg viewBox="-1 -1 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.349365 8.16602L3.56226 4.95312L0.349365 1.74023L1.18335 0.90625L4.39624 4.11914L7.60913 0.90625L8.44312 1.74023L5.23022 4.95312L8.44312 8.16602L7.60913 9L4.39624 5.78711L1.18335 9L0.349365 8.16602Z" />
</svg>
